<div class="footer-list">

    <div *ngIf="item?.price > 0" class="footer-list__row">
        <span class="footer-list__row-name">{{item.name}}</span>
        <span>{{item.price | multiCurrency}}</span>
    </div>

    <div *ngFor="let row of items" class="footer-list__row" [class.footer-list__row--indent]="row.indent">
        <div *ngIf="row.prefix" class="footer-list__row-text">
            <span class="footer-list__row-prefix">{{row.prefix}}</span>
            <span class="footer-list__row-name">{{row.name}}</span>
        </div>
        <div *ngIf="!row.prefix" class="footer-list__row-name">
            <b *ngIf="row.qty > 1">{{row.qty}}x </b>
            {{row.name}}
        </div>
        <span *ngIf="row.total > 0">{{ (row.showPlus || row.indent) ? '+' : '' }}{{row.total | multiCurrency}}</span>
    </div>

</div>
